<template>
	<div class="modal" v-if='isModal'>
		<div class="work">Работает?
			<input title="isWork" type="checkbox" v-model="isWork">
		</div>

		<div class="time">
			<input title="begin" type="time" class="begin" v-model='begin' :disabled="!isWork">
			<input title="end" type="time" class="end" v-model='end' :disabled="!isWork">
		</div>

		<div class="buttons">
			<button @click="validTime">{{(!!_id) ? 'Обновить' : 'Добавить'}}</button>
			<button @click="closeModal">Отмена</button>
		</div>
	</div>
</template>

<script>
	import moment from 'moment'
	import Time from '@/common/UTC'

	export default {
		name: "TimeModal",
		mounted() {
			this.$event.connect('openTimeModal', (data) => {
				this.begin = Time.toLocal(data.begin);
				this.end = Time.toLocal(data.end);

				this.pickerDate = data.pickerDate || '';

				this._id = data._id;
				this.isSpecial = data.isSpecial || false;

				this.isModal = true
			});

			this.$event.connect('closeTimeModal', () => this.closeModal())
		},
		beforeDestroy() {
			this.$event.disconnect(['openTimeModal', 'closeTimeModal'])
		},
		data() {
			return {
				_id: '',
				isModal: false,
				isWork: true,
				begin: '',
				end: '',
				pickerDate: '',
				isSpecial: false
			}
		},
		methods: {
			validTime() {
				if ((this.begin && this.end) || !this.isWork)
					this.sendResponse();
				else
					this.$event.toast('i', "Укажите время работы или снимите галочку")
			},
			convertTimeToHuman(time) {
				if (time) {
					return moment(time, 'X').format('HH:mm');
				}

				return ''
			},
			convertTimeToTS(time) {
				if (time) {
					return moment(time, 'HH:mm').format('X');
				}

				return ''
			},
			sendResponse() {
				if (this.isSpecial) {
					this.$event.send('scheduleSpecialEditorRecord', {
						begin: this.convertTimeToTS(this.begin),
						end: this.convertTimeToTS(this.end),
						pickerDate: this.pickerDate || '',
						isWork: this.isWork,
						_id: this._id
					})
				} else {
					this.$event.send('scheduleEditorRecord', {
						begin: Time.toUTC(this.begin) || '',
						end: Time.toUTC(this.end) || '',
						isWork: this.isWork
					})
				}

				this.closeModal()
			},
			closeModal() {
				this.isSpecial = false;
				this.isWork = true;
				this.isModal = false;

				this.begin = '';
				this.end = '';
				this.pickerDate = '';
			}
		}
	}
</script>

<style scoped>
	.modal {
		display: block;
		max-width: 80%;
		position: absolute;
		top: 50%;
		padding: 20px;
		background: rgba(84, 88, 111, 0.85);
		border-radius: 0;
		text-align: center;
		left: 0;
		right: 0;
		margin-left: auto;
		margin-right: auto;
		z-index: 10;
	}

	.modal > .time, .modal > .work, .modal > .buttons {
		width: 100%;
		margin: 0 0 10px;
		color: #fff;
	}

	.modal button {
		background: #11bac0;
		border: none;
		border-radius: 0;
		box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.30);
		font: 100% 'Calibri', Helvetica, Arial, sans-serif;
		height: 28px;
		color: #fff;
	}

	.modal input[type="checkbox"] {
		width: 15px;
		height: 15px;
	}

	.modal input.begin,
	.modal input.end {
		border-radius: 0;
		border: none;
		padding: 4px 4px 4px 5px;
		color: #333;
	}
</style>



// WEBPACK FOOTER //
// TimeModal.vue?78b01bbc